import { render, staticRenderFns } from "./jiaopi.vue?vue&type=template&id=01704aba&scoped=true&"
import script from "./jiaopi.vue?vue&type=script&lang=js&"
export * from "./jiaopi.vue?vue&type=script&lang=js&"
import style0 from "./jiaopi.vue?vue&type=style&index=0&id=01704aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01704aba",
  null
  
)

export default component.exports